import { GeneratedQuery } from "../graphql";
import * as APITypes from "../API";
/* tslint:disable */
/* eslint-disable */

export const getZoneParticipantPaging = /* GraphQL */ `
  query GetZoneParticipantPaging(
    $zoneId: String!
    $nextToken: String
    $limit: Int
  ) {
    getZone(zoneId: $zoneId) {
      zoneId
      title
      branding
      participants(nextToken: $nextToken, limit: $limit) {
        items {
          zoneId
          participantId
          username
          groups
          authenticated
          __typename
        }
        nextToken
        __typename
      }
      participation {
        zoneId
        participantId
        username
        groups
        authenticated
        __typename
      }
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetZoneParticipantPagingQueryVariables,
  APITypes.GetZoneParticipantPagingQuery
>;
